import { assertNotNullish, pushIf } from '@eturi/util'
import { toParamsURL } from '@op/util'
import { bindCreateAsyncThunkToState } from '../bindCreateAsyncThunkToState.js'
import type { HttpExtra } from '../http.js'
import type { WithFeatureFlagsState, WithOnboardingState } from '../reducers/index.js'
import type { SystemInfo, SystemInfoType } from '../types/SystemInfo.js'

type SystemInfoThunkState = WithFeatureFlagsState & WithOnboardingState

const createAsyncThunk = /*@__PURE__*/ bindCreateAsyncThunkToState<SystemInfoThunkState>()

type SystemInfoArg = HttpExtra & {
	readonly flags?: boolean
	readonly onboarding?: boolean
}

export const fetchSystemInfo = /*@__PURE__*/ createAsyncThunk(
	'systemInfo/fetch',
	async (
		{ flags, onboarding, ...extra }: SystemInfoArg = {
			flags: true,
			onboarding: true,
		},
		{ dispatch, extra: { http } },
	) => {
		// At least one of flags or onboarding must be true. If both are falsey, default to true.
		if (!(flags || onboarding)) {
			flags = onboarding = true
		}

		const extras = (
			[
				...pushIf(flags, 'feature_flags' as const),
				...pushIf(onboarding, 'onboarding_choices' as const),
			] satisfies SystemInfoType[]
		).join(',')

		const url = toParamsURL('/system', { extras })
		const systemInfo = await dispatch(
			http.get<Maybe<Partial<SystemInfo>>>(url, { ...extra, isUnauthenticated: true }),
		)

		assertNotNullish(systemInfo, 'SystemInfo')

		return systemInfo
	},
)
